<template>
  <div id="E0-2" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <nav id="enb" class="step3">
        <ul class="inner_static">
          <li class="category">
            <router-link to="/kagull/planning/category">
              <span class="item">Category:</span><strong class="cnt">{{this.selectedCategory.categoryCaption}}</strong>
            </router-link>
          </li>
          <li class="style" v-if="this.selectedStyle.styleId">
            <a @click="backSelectStyle()">
              <span class="item">Style:</span><strong class="cnt">{{this.selectedStyle.styleName}}</strong>
            </a>
          </li>
        </ul>
      </nav>
      <div id="content">
        <kg-style-panel v-if="!this.selectedStyle.styleId"
        :selectedCategoryId="this.selectedCategory.categoryId"
        @selectStyleEvent="selectStyle($event)"/>
        <kg-plan-panel v-if="this.selectedStyle.styleId"
        :selectedStyleId="this.selectedStyle.styleId"
        @selectPlanEvent="selectPlan($event)"
        @toSizeInputEvent="toSizeInput()"/>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kaggul Module
import Header from '../components/common/HomeIconHeader'
import CategoryPanel from '../components/planning/CategoryPanel'
import StylePanel from '../components/planning/StylePanel'
import PlanPanel from '../components/planning/PlanPanel'

export default {
  components: {
    'kg-header': Header,
    'kg-category-panel': CategoryPanel,
    'kg-style-panel': StylePanel,
    'kg-plan-panel': PlanPanel
  },
  data () {
    return {
      plans: [],
      selectedCategory: {},
      selectedStyle: {},
      selectedPlan: {},
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    init: function () {
      this.selectedCategory = App.getLocalStorage(KG_STORAGE_KEY.SELECT_CATEGORY_DATA)
    },
    selectStyle: function (style) {
      // ローカルストレージを削除
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_STYLE_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
      App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
      // スタイル選択時の処理
      App.setLocalStorage(KG_STORAGE_KEY.SELECT_STYLE_DATA, style)
      this.selectedStyle = style
    },
    selectPlan: function (plan) {
      // ローカルストレージを削除
      App.removeLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
      App.removeLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
      App.removeLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
      // プラン選択時の処理
      App.setLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA, plan)
      this.selectedPlan = plan
    },
    toSizeInput: function () {
      console.log('kagull_app?plan_id=' + this.selectedPlan.kgFdId)
      /* eslint-disable */
      Unity.call('kagull_app?plan_id=' + this.selectedPlan.kgFdId)
    },
    backSelectStyle: function () {
      this.selectedStyle = {}
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/FpSelect.vue